import axiosInstance from '../api.service.js';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = "Job/";

const getJobsByClient = async (clientId) => await axiosInstance.get(ENDPOINTORIGIN + 'GetJobsByClient?clientId=' + clientId, constants.REQUIRE_INTERCEPTORS);

const getJobs = async () => await axiosInstance.get(ENDPOINTORIGIN + 'GetJobs', constants.REQUIRE_INTERCEPTORS);

const getCompletedJobs = async () => await axiosInstance.get(ENDPOINTORIGIN + 'GetCompletedJobs', constants.REQUIRE_INTERCEPTORS);

const getJobLocations = async (jobId) => await axiosInstance.get(ENDPOINTORIGIN + 'GetJobLocations?jobId=' + jobId, constants.REQUIRE_INTERCEPTORS);

const getJobCardInfo = async (jobId) => await axiosInstance.get(ENDPOINTORIGIN + 'GetJobCardInfo?jobId=' + jobId, constants.REQUIRE_INTERCEPTORS);

const getJobById = async (jobId) => await axiosInstance.get(ENDPOINTORIGIN + 'GetJobById?jobId=' + jobId, constants.REQUIRE_INTERCEPTORS);

const completeJob = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'CompleteJob', model, constants.REQUIRE_INTERCEPTORS);

const getWeekDayDifferenceBetweenTwoDates = async (start, end) => await axiosInstance.get(ENDPOINTORIGIN + 'GetWeekDayDifferenceBetweenTwoDates?start=' + start + '&end=' + end, constants.REQUIRE_INTERCEPTORS);

const saveJob = async (job) => await axiosInstance.post(ENDPOINTORIGIN + 'SaveJob', job, constants.REQUIRE_INTERCEPTORS);

export {
    getJobsByClient,
    getJobs,
    getJobCardInfo,
    getJobById,
    getWeekDayDifferenceBetweenTwoDates,
    saveJob,
    completeJob,
    getCompletedJobs,
    getJobLocations
}